<script>
import {Bubble} from 'vue-chartjs'
import {Chart as ChartJS, Title, Tooltip, Legend, PointElement, CategoryScale, LinearScale} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, PointElement, CategoryScale, LinearScale)

export default {
  name: 'FarmerBenchmarkChart',
  components: {Bubble},
  props: {
    chartId: {
      type: String,
      default: 'bar-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 400
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => {
      }
    },
    plugins: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chartData: {},
      chartOptions: {
        events: [],
        pointStyle: 'circle',
        responsive: true,
        indexAxis: 'x',
        scales: {
          x: {
            grid: {
            },
            ticks: {
              color: "black"
            }
          },
          y: {
            grid: {
              display: false,
              drawBorder: false,
            },
            ticks: {
              display: false
            }
          }
        },
        plugins: {
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              color: 'black',
              usePointStyle: 'true',
              font: {
                size: 18
              }
            },
          }
        },
      }
    }
  },

  methods: {
    setData(data) {
      this.chartData = data
      this.chartData.datasets[2].backgroundColor += "BB";
    },
  }
}
</script>

<template>
  <div class="rounded bg-secondary m-2 p-2">
    <Bubble
        :chart-options="chartOptions"
        :chart-data="chartData"
        :chart-id="chartId"
        :dataset-id-key="datasetIdKey"
        :plugins="plugins"
        :css-classes="cssClasses"
        :styles="styles"
        :width="width"
        :height="height"
        :ref="chartId"
    />
  </div>
</template>